import { render } from "./KnotSelect.vue?vue&type=template&id=4de698c3&scoped=true"
import script from "./KnotSelect.vue?vue&type=script&lang=js"
export * from "./KnotSelect.vue?vue&type=script&lang=js"

import "./KnotSelect.vue?vue&type=style&index=0&id=4de698c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de698c3"]])

export default __exports__